<template>
  <div>
    <v-container fluid>
      <alert v-if="!agreeTerms">
        <template v-slot:contents>
          <div class="text-body-1">
            2022年4月15日、<u><a class="d-inline-flex align-baseline" href="https://cavin.ooo/terms-1" target="_blank">
            利用規約<v-icon color="#2196f3" small>mdi-open-in-new</v-icon></a></u>を改定いたしました。
          </div>
          <div class="text-body-1">変更後の内容をご確認いただき、同意される場合は、チェックボックスにチェックを入れて「利用する」ボタンを押してください。</div>
        </template>
        <template v-slot:actions>
          <div class="d-flex flex-column">
            <v-checkbox label="利用規約の内容を確認しました。" v-model="agree" class="ma-0" hide-details />
            <v-btn :disabled="!agree" color="info" outlined class="mt-4" @click="agreetment">利用する</v-btn>
          </div>
        </template>
      </alert>
      <div v-if="data.harvests_count > 0">
        <h3 class="text-subtitle-1 grey--text text--darken-3 mb-1">出荷の準備</h3>
        <SmallItem url="/farm/order_items">
          <div class="d-flex align-center">
            <FlowerIcon color="#FF8C71" class="mr-2" style="width: 16px" />
            <span v-html="$t('schedule_ship_today')(data.order_items_count_today)" />
          </div>
        </SmallItem>

        <SmallItem url="/farm/order_items">
          <div class="d-flex align-center">
            <DocumentIcon color="#5FAEDB" class="mr-2" style="width: 16px" />
            <span v-html="$t('orders_and_reservations')(data.confirmed_order_item_count, data.request_order_items_count)" />
          </div>
        </SmallItem>

        <SmallItem url="/farm/conversations">
          <div class="d-flex align-center">
            <FeedbackIcon color="#82C75C" class="mr-2" style="width: 16px" />
            <span v-html="$t('new_messages')(data.unread_messages_count)" />
          </div>
        </SmallItem>

        <div v-if="data.order_items_count > 0">
          <h3 class="text-subtitle-1 grey--text text--darken-3 mt-4 mb-1">書類の管理</h3>
          <SmallItem url="/farm/shipping_results">
            <div class="d-flex align-center">
              <DocumentIcon color="#5FAEDB" class="mr-2" style="width: 16px" />
              <span v-html="$t('show_shipping_results')" />
            </div>
          </SmallItem>

          <SmallItem url="/farm/pdf_picker">
            <div class="d-flex align-center">
              <ChartlineIcon color="#E38C00" class="mr-2" style="width: 16px" />
              <span v-html="$t('download_report')" />
            </div>
          </SmallItem>
        </div>
      </div>

      <h2 class="text-subtitle-1 grey--text text--darken-3 mt-4 mb-1">基本機能</h2>
      <SmallItem url="/farm/flower_detail">
        <div class="d-flex align-center">
          <FlowerIcon color="#E38C00" class="mr-2" style="width: 16px" />
          <span v-html="$t('add_product')" />
          <v-icon>mdi-checked</v-icon>
        </div>
      </SmallItem>

      <SmallItem v-if="data.flowers_count > 0" url="/farm/harvest">
        <div class="d-flex align-center">
          <FlowerIcon color="#5FAEDB" class="mr-2" style="width: 16px" />
          <span v-html="$t('save_flower_harvest')" />
        </div>
      </SmallItem>
    </v-container>
  </div>
</template>

<script>
import SmallItem from "@/components/farm/dashboard/SmallItem.vue";
import FlowerIcon from "@/components/icons/FlowerIcon.vue";
import DocumentIcon from "@/components/icons/DocumentIcon.vue";
import FeedbackIcon from "@/components/icons/FeedbackIcon.vue";
import ChartlineIcon from "@/components/icons/ChartlineIcon.vue";
import Alert from "@/components/shared/Alert.vue";
import { formatDate } from "@/plugins/i18n";

export default {
  components: {
    FlowerIcon,
    DocumentIcon,
    SmallItem,
    FeedbackIcon,
    ChartlineIcon,
    Alert
  },
  data() {
    return {
      mobile: this.$vuetify.breakpoint.xs,
      agree: false
    };
  },
  computed: {
    month() {
      const d = new Date();
      const m = d.getMonth() + 1;

      if (d.getDate() < 15) {
        const nd = new Date(d.getFullYear(), m - 1, 0);
        return formatDate(nd, "m月16日〜m月d日");
      }

      return formatDate(d, "m月1日〜m月15日");
    },
    data() {
      return this.$store.state.farmDashboard;
    },
    isRequest() {
      return this.$store.state.farmDashboard.request_order_items_count !== 0;
    },
    agreeTerms() {
      return this.$store.state.auth.agree_terms;
    }
  },

  created() {
    this.$store.dispatch("getDashboardData");
  },

  methods: {
    async agreetment() {
      const res = await this.$http("put", "users/agree_terms");
      if (res.status === 200) { this.$store.dispatch("agreement"); }
    }
  }
};
</script>

<style scoped>
</style>
